import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TableModule } from 'primeng/table';
import { TransactDetailsComponent } from '../transact-details/transact-details.component';
import { PanelModule } from '../../../modules/panel.module';
import { BusinessListComponent } from '../../business/business-list/business-list.component';
import { OrderService } from '../../../services/order.service';

@Component({
  selector: 'brt-transact-list',
  standalone: true,
  imports: [PanelModule, TableModule, BusinessListComponent, TransactDetailsComponent],
  templateUrl: './transact-list.component.html',
  styleUrl: './transact-list.component.css',
})
export class TransactListComponent {
  basePath = this.route.snapshot.data['basePath'] || '/';
  constructor(private route: ActivatedRoute, public router: Router, private orderService: OrderService) {
    route.params.subscribe(async params => {
      this.businessId = params['bid'];
      await this.load();
    });
  }

  loading: boolean;
  businessId: any;
  transacts: any[];
  // total: number;
  // limit = 20;

  private async load() {
    if (!this.businessId) return;
    this.loading = true;
    const result = await this.orderService.getTransacts(this.businessId);
    this.transacts = result;
    // this.total = result.Total;
    this.loading = false;
  }
}
